module.exports = __webpack_public_path__ + "08_hige_black.7709a984.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer3/08_hige_black.png
// module id = 5Epf
// module chunks = 0